import { useState, useCallback } from 'react';
import { expertOrdersApi } from '../../../api/expertDashboardApis/expertOrderApis/expertOrders.api'; // Adjust path exactly to your setup
import { toast } from 'sonner';

export interface OrderRecord {
  id: string;
  session_unique_id: string;
  expert_code: string;
  user_code: string;
  user_name: string | null;
  session_type: 'chat' | 'call' | 'video';
  status: 'completed';
  started_at: string;
  ended_at: string;
  duration_seconds: number;
  user_paid: number;       // maps to cs.user_wallet_deduction
  expert_earned: number;   // maps to cs.expert_final_wallet_addition
  pg_charges: number;      // maps to cs.expert_pg_fee
  admin_earned: number;    // maps to cs.admin_earning
}

export const useExpertOrders = () => {
  const [orders, setOrders] = useState<OrderRecord[]>([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);

  // 🟢 EXTENDED STATE MATRIX: Added custom date ranges and full month tracking parameters
  const [filters, setFilters] = useState({
    page: 1,
    limit: 20,
    sessionType: 'all',
    startDate: '',
    endDate: '',
    month: '', // Expects full words like "January", "February", etc.
    year: ''
  });

  // Fetch structural earnings breakdown from session records
  const fetchOrders = useCallback(async (customFilters?: typeof filters) => {
    setIsLoadingOrders(true);
    const targetFilters = customFilters || filters;
    try {
      const response = await expertOrdersApi.getExpertOrders(targetFilters);
      if (response.success) {
        setOrders(response.data || []);
        setTotalOrders(response.total || 0);
      }
    } catch (error: any) {
      console.error('Fetch Expert Orders Error:', error);
      toast.error(error.response?.data?.message || 'Failed to load consultation orders');
    } finally {
      setIsLoadingOrders(false);
    }
  }, [filters]);

  return {
    orders,
    totalOrders,
    isLoadingOrders,
    filters,
    setFilters,
    fetchOrders
  };
};